exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_coverImageError_keFXVzyw18J-3Mb5Owsk8 {\n  display: inline-block;\n  padding: 8px 16px;\n  background: #f5f5f5;\n  color: #666;\n  font-family: Segoe UI, sans-serif;\n  text-align: center;\n}\n\n.IA_coverImageErrorTitle_1mwUpRnB3npwKUnviwnVGO {\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.IA_coverImageErrorMessage_17BB31Hv8Gw2TfxR7BWBwu {\n  font-size: 13px;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_coverImageError": "IA_coverImageError_keFXVzyw18J-3Mb5Owsk8",
	"IA_coverImageErrorTitle": "IA_coverImageErrorTitle_1mwUpRnB3npwKUnviwnVGO",
	"IA_coverImageErrorMessage": "IA_coverImageErrorMessage_17BB31Hv8Gw2TfxR7BWBwu"
};